import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};

  `;
};

export const Container = styled.div`
  display: grid;
  grid-template-columns: 45% 45%;
  justify-content: space-between;
  margin-top: 16px;
  ${handleQuery(css`
    grid-template-columns: 100%;
    gap: 16px;
  `)}
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${handleQuery(css`
    flex-direction: column;
  `)}
`;

export const HeaderInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  background-color: #0000c9;
`;

export const Retangle = styled.div`
  width: 30px;
  height: 5px;
  border-radius: 4px;
  margin-top: 3px;
  background-color: ${({ color }) => color};
`;
